var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.77,9.64c-.52-.35-1.07-.58-1.7-.64-.23-.02-.15-.23-.15-.36,0-1.35-.02-2.71,0-4.06,0-.38-.07-.51-.49-.51-4.29.02-8.58.02-12.88,0-.41,0-.49.13-.49.51.02,1.35,0,2.71.01,4.06,0,.24-.04.36-.32.39-.56.05-1.07.29-1.57.64,0-2.03-.05-3.99.02-5.95.03-.92.96-1.59,1.94-1.6,1.85,0,3.69,0,5.54,0,2.67,0,5.33,0,8,0,1.35,0,2.15.79,2.15,2.13,0,1.65,0,3.31,0,4.96,0,.13.04.27-.06.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.09,17.87c-.63,0-1.26,0-1.89,0-.7,0-1.09-.44-1.02-1.13.09-1,.88-1.78,1.89-1.81.7-.02,1.39-.02,2.09,0,1.02.04,1.83.84,1.89,1.86.04.65-.34,1.07-1,1.08-.66,0-1.31,0-1.97,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m9.98,17.87c-.63,0-1.26,0-1.89,0-.7,0-1.09-.44-1.02-1.13.09-1,.88-1.78,1.89-1.81.7-.02,1.39-.02,2.09,0,1.02.04,1.83.84,1.89,1.86.04.65-.34,1.07-1,1.08-.66,0-1.31,0-1.97,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.86,17.87c-.63,0-1.26,0-1.89,0-.69,0-1.08-.45-1.01-1.14.09-1,.89-1.77,1.9-1.8.68-.02,1.37-.02,2.05,0,1.03.03,1.84.81,1.92,1.83.05.67-.33,1.11-1,1.11-.66,0-1.31,0-1.97,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.07,11.95c.01,1.06-.88,1.97-1.93,1.99-1.07.02-1.99-.9-1.99-1.97,0-1.06.9-1.96,1.95-1.97,1.06,0,1.96.89,1.97,1.95Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10,13.94c-1.06,0-1.95-.9-1.96-1.96,0-1.07.91-1.99,1.98-1.98,1.06.01,1.95.92,1.94,1.98,0,1.06-.91,1.96-1.96,1.95Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.93,11.93c.02-1.06.93-1.95,1.99-1.93,1.07.02,1.97.96,1.93,2.03-.04,1.07-.95,1.94-2.01,1.91-1.06-.03-1.94-.95-1.91-2.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/People.ff3a84f4f44d7b5acc4f2bac7fef64b7.svg";
export { ForwardRef as ReactComponent };